<div class="fluid formgrid grid">

  <div class="field lg:col-4 sm:col-12">
    <label for="DDCE1" class="do-not-wrap-text">{{docOptText1}}</label>
    <p-dropdown id="DDCE1" [options]="options1" [(ngModel)]="selected1" editable="true" tooltip="docOptText1"></p-dropdown>
  </div>
  <div class="field lg:col-4 sm:col-12">
    <label for="DDCE2" class="do-not-wrap-text">{{docOptText2}}</label>
    <p-dropdown id="DDCE2" [options]="options2" [(ngModel)]="selected2" editable="true" tooltip="docOptText2"></p-dropdown>
  </div>
  <div class="field lg:col-4 sm:col-12">
    <label for="DDCE3" class="do-not-wrap-text">{{docOptText3}}</label>
    <p-dropdown id="DDCE3" [options]="options3" [(ngModel)]="selected3" editable="true" tooltip="docOptText3"></p-dropdown>
  </div>
  <div class="field lg:col-2 sm:col-4">
    <label for="DC4" class="do-not-wrap-text">{{docDelvTerms}}</label>
    <input id="DC4" type="number" pInputText [(ngModel)]="document.DOCDLVTERM" required value="document.DOCDLVTERM" min="0" step="1" />
  </div>
  <div class="field lg:col-10 sm:col-8">
    <label for="DC3" class="do-not-wrap-text">{{docDelvConds}}</label>
    <div class="p-inputgroup">
      <input id="DC3" type="text" pInputText [(ngModel)]="document.DOCDLVBASE" required value="document.DOCDLVBASE"/>
      <p-button label="Заполнить" icon="pi pi-pencil" styleClass="p-button-success ml-1 hide-label" (onClick)="onFillDeliveryConditions($event)"></p-button>
    </div>
  </div>
  <div class="field col-12">
    <label for="DN1" class="do-not-wrap-text">{{docNoteText1}}</label>
    <input id="DN1" type="text" pInputText [(ngModel)]="document.DOCNOTE1" value="document.DOCNOTE1"/>
  </div>
  <div class="field col-12">
    <label for="DN2" class="do-not-wrap-text">{{docNoteText2}}</label>
    <input id="DN2" type="text" pInputText [(ngModel)]="document.DOCNOTE2" value="document.DOCNOTE2">
  </div>
</div>
